<script>
    import { classNames } from "../../utils";
    //'mini' | 'small' | 'middle'|'large'
    export let size = "middle";
    //'default' | 'primary' | 'success' | 'warning' | 'danger'
    export let color = "default";
    export let disabled = false;
    export let block = false;
    let el;
    let cls = "sui-btn";
    //
    function start() {
        el && el.classList.add("active");
    }
    //
    function end() {
        el && el.classList.remove("active");
    }
</script>

<div
    class={classNames({
        [cls]: cls,
        [color]: color,
        [size]: size,
        [$$props.class]: $$props.class,
    })}
    class:disabled
    class:block
    bind:this={el}
    role="button"
    tabindex="0"
    on:click
    on:touchstart={start}
    on:touchend={end}
    on:mousedown={start}
    on:mouseup={end}
>
    <slot>按钮</slot>
</div>

<style lang="less">
    @import "./button.less";
</style>
